import React, { useCallback, useEffect, useState } from "react";
import "./index.scss";
import UserTaskList from "../../../common_components/user-task-list/component";
import {
  MY_TASK_PAGE_DATAGRID_STATE_STORAGE_KEYS,
  MY_TASK_PAGE_TABS,
} from "../../my-tasks/constant";
import { GET_USER_TASK_LIST_BY_LEVEL } from "../../../common_components/user-task-list/services/get-user-task-list-by-level";
import { actions } from "async-ops";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import dxDataGrid from "devextreme/ui/data_grid";

interface IUserTasksProps {
  data: any;
  isExternalUser?: boolean;
}

const UserTasks: React.FC<IUserTasksProps> = (props) => {
  let taskDataPrefix = props?.data?.data?.eaCaseId;
  const dispatch = useDispatch();

  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: actions.asyncOperationStart,
    },
    dispatch
  );

  useEffect(() => {
    asyncAction.asyncOperationStart(GET_USER_TASK_LIST_BY_LEVEL, {
      attachedLevelId: props?.data?.data?.eaCaseId,
      attachedLevelName: "EAC",
      includeNonAttachedLevelTasks: false,
      isShowOpenTaskOnly: true,
      taskDataPrefix,
    });
  }, [props?.data?.data?.eaCaseId]);

  const refreshActiveTasks = useCallback(async () => {
    try {
      await asyncAction.asyncOperationStart(GET_USER_TASK_LIST_BY_LEVEL, {
        attachedLevelId: props?.data?.data?.eaCaseId,
        attachedLevelName: "EAC",
        includeNonAttachedLevelTasks: false,
        isShowOpenTaskOnly: true,
        taskDataPrefix,
      });
      const dataGrid = dxDataGrid.getInstance(
        document.getElementById('pnlCaseListDetailGrid')
      ) as dxDataGrid;
      dataGrid.getDataSource().reload();
    } catch (error) {
      console.error("Error refreshing tasks or cases", error);
    }
  }, [
    props?.data?.data?.eaCaseId,
  ]);
  

  return (
    <div>
      <div>Task List</div>
      <UserTaskList
        isUserTaskBulkOptionVisible={false}
        doNotLoadDatasourcesInd={false}
        excelExportFileName="User Open Tasks"
        isFromMyTaskPage={false}
        refreshUserTaskListFunction={refreshActiveTasks}
        userTaskListStateStoringKey={
          MY_TASK_PAGE_DATAGRID_STATE_STORAGE_KEYS.ACTIVE_TASKS_TAB
        }
        myTasksPageOptions={{
          myTasksPageTabName: MY_TASK_PAGE_TABS.ACTIVE_TASKS_TAB,
        }}
        isExternalUser={props.isExternalUser}
        isToolBarNotVisible={true}
        isUserTaskChartVisible={false}
        caseData={props?.data?.data}
      ></UserTaskList>
    </div>
  );
};

export default UserTasks;
